import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { CurrentLoginStylingService } from '@modules/common/services/current-login-styling.service';

@Component({
    selector: 'app-login-theming',
    templateUrl: './login-theming.component.html',
    styleUrls: ['./login-theming.component.scss']
})
export class LoginThemingComponent implements OnInit {
    public style!: string;

    @ViewChild('my_style', { static: true })
    private _my_style!: ElementRef;

    constructor(
        private _currentLoginStylingService: CurrentLoginStylingService,
    ) { }

    private ConvertHexToRGB(hex: string): number[] {
        let rString = hex.substr(1, 2);
        let gString = hex.substr(3, 2);
        let bString = hex.substr(5, 2);

        return [parseInt(rString, 16), parseInt(gString, 16), parseInt(bString, 16)];
    }

    public ngOnInit(): void {
        this._currentLoginStylingService.configChanged.subscribe(result => {
            if (result) {
                let primaryColor: string = result.primaryColor || '#004C97';
                let secondaryColor: string = result.secondaryColor || '#DEDCDC';
                let tertiaryColor: string = result.tertiaryColor || '#4E9499';

                let disabledColor: string = '#d0d0d0';
                let primaryRGB: number[] = this.ConvertHexToRGB(primaryColor);
                let invalidColor: string = '#f44336';

                this._my_style.nativeElement.innerHTML = `
<style>
    .recovery-method a {
        color: ` + primaryColor + ` !important;
    }
    .contact-method.checked .contact-method-details {
        border-bottom-color: ` + primaryColor + ` !important;
    }
    .login-title {
        color: ` + primaryColor + ` !important;
    }
    .login-btn-submit,
    .mat-button.login-btn-submit {
        border-color: ` + primaryColor + ` !important;
        color: ` + primaryColor + ` !important;
    }
    .login-btn-submit:hover:not(:disabled),
    .login-btn-submit:focus {
        background-color: rgba(` + primaryRGB[0] + `, ` + primaryRGB[1] + `, ` + primaryRGB[2] + `, 0.1) !important;
    }
    .login-btn-submit[disabled], .mat-button.login-btn-submit[disabled] {
        border-color: ` + disabledColor + ` !important;
        color: ` + disabledColor + ` !important;
    }
    .login-input-icon {
        color: ` + primaryColor + ` !important;
    }
    .login-main-submit {
        background-color: ` + primaryColor + ` !important;
    }
    .login-workflow-footer-icon {
        color: ` + primaryColor + ` !important;      
    }
    .mat-mdc-radio-button.mat-accent.mat-mdc-radio-checked .mdc-radio__outer-circle {
        border-color: ` + primaryColor + ` !important;
    }
    .mat-mdc-radio-button.mat-accent .mdc-radio__inner-circle {
        border-color: ` + primaryColor + ` !important;
    }
    .mat-checkbox-checked.mat-accent .mat-checkbox-background,
    .mat-checkbox-indeterminate.mat-accent .mat-checkbox-background {
        background-color: ` + primaryColor + ` !important;
    }
    .mat-ripple-element {
        background-color: rgba(` + primaryRGB[0] + `, ` + primaryRGB[1] + `, ` + primaryRGB[2] + `, 0.2) !important;
    }
    .fa,
    .mat-datepicker-toggle {
        color: ` + primaryColor + ` !important;
    }
    .button-flat,
    .button-flat-add,
    .button-flat.mat-button,
    .button-flat-add.mat-button {
        color: ` + primaryColor + ` !important;
        border-color: ` + primaryColor + ` !important;
    }
    .mat-input-element {
        caret-color: ` + primaryColor + ` !important;
    }
    .mat-form-field-invalid .mat-input-element, .mat-warn .mat-input-element {
        caret-color: ` + invalidColor + ` !important;
    }
    .mat-form-field-ripple {
        background-color: ` + primaryColor + ` !important;
    }
    .mat-form-field-invalid .mat-form-field-ripple {
        background-color: ` + invalidColor + ` !important;
    }
    .mat-focused .mat-form-field-label {
        color: ` + primaryColor + ` !important;
    }
    .mat-form-field-invalid .mat-form-field-label {
        color: ` + invalidColor + ` !important;
    }

    .login-layout-main-text {
        background-color: ` + secondaryColor + ` !important;
    }

    .mat-tab-label {
        color: ` + tertiaryColor + ` !important;
    }
    .page-header {
        color: ` + primaryColor + ` !important;
    }
</style>`;
            }
        });
        // .page-header uses tertiaryColor in site.scss, but for the
        // login account settings page (which is the only place the
        // class is used) we want the headers to be the primary color.
    }
}
